import ApplicationRecord from './ApplicationRecord';
export default class Contact
  extends ApplicationRecord({
    /**
   * @type {Number}
   */
    ID: 0,
    ContactType: '',
    Telephone: '',
    Fax: '',
  }) {}



// WEBPACK FOOTER //
// ./src/models/Contact.js